// ----------------------------------------------------------------------

function pxToRem(value) {
    return `${value / 16.8}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
    return {
        "@media (min-width:600px)": {
            fontSize: pxToRem(sm),
        },
        "@media (min-width:900px)": {
            fontSize: pxToRem(md),
        },
        "@media (min-width:1200px)": {
            fontSize: pxToRem(lg),
        },
    };
}

const FONT_PRIMARY = "Inter";

const typography = {
    fontFamily: FONT_PRIMARY,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 600,
    h1: {
        fontWeight: 600,
        lineHeight: "33px",
        fontSize: 28,
    },
    h2: {
        fontWeight: 400,
        lineHeight: 64 / 48,
        fontSize: pxToRem(24),
        ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
    },
    h3: {
        fontWeight: 600,
        lineHeight: "28px",
        fontSize: 24,
    },
    h4: {
        fontWeight: 600,
        lineHeight: 1.5,
        fontSize: pxToRem(20),
    },
    h5: {
        fontWeight: 600,
        lineHeight: "22px",
        fontSize: 18,
        color: "#090932",
    },
    h6: {
        fontWeight: 600,
        lineHeight: 28 / 18,
        fontSize: pxToRem(17),
        ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
    },
    subtitle1: {
        fontWeight: 400,
        lineHeight: 22 / 18,
        fontSize: pxToRem(18),
    },
    subtitle2: {
        fontWeight: 600,
        lineHeight: 22 / 14,
        fontSize: pxToRem(14),
    },
    body1: {
        fontWeight: 600,
        lineHeight: "20px",
        fontSize: 14,
    },
    body2: {
        lineHeight: 22 / 14,
        fontSize: pxToRem(14),
    },
    body3: {
        lineHeight: "20px",
        fontSize: 14,
        fontWeight: 600,
        color: "#090932",
    },
    body4: {
        lineHeight: "20px",
        fontSize: 14,
        fontWeight: 400,
        color: "#656C7B",
    },
    body5: {
        lineHeight: "16px",
        fontSize: 12,
        fontWeight: 600,
        color: "#656C7B",
    },
    caption: {
        lineHeight: 1.5,
        fontSize: pxToRem(12),
    },
    overline: {
        fontWeight: 600,
        lineHeight: 1.5,
        fontSize: pxToRem(12),
        letterSpacing: 1.1,
        textTransform: "uppercase",
    },
    button: {
        fontWeight: 600,
        lineHeight: 24 / 14,
        fontSize: pxToRem(14),
        textTransform: "capitalize",
    },
    graphLabel1: {
        fontWeight: 400,
        lineHeight: "14px",
        fontSize: 11,
        textTransform: "capitalize",
    },
    sectionTitle1: {
        fontWeight: 400,
        lineHeight: "22px",
        fontSize: "16px",
        color: "#090932",
    },
    sectionTitle2: {
        fontWeight: 600,
        lineHeight: "20px",
        fontSize: "14px",
        color: "#090932",
    },
    sectionContent: {
        fontWeight: 400,
        lineHeight: "22px",
        fontSize: "14px",
        color: "#090932",
    },

    // As Per the Figma Configuration
    // Header 1
    typography1: {
        fontSize: "28px",
        fontWeight: 600,
        lineHeight: "35px",
        letterSpacing: "0.2px",
    },
    // Header 2
    oldTypography2: {
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: "28px",
        letterSpacing: "0.2px",
    },
    // Subheader 1
    oldTypography3: {
        fontSize: "24px",
        fontWeight: 400,
        lineHeight: "28px",
        letterSpacing: "0.2px",
    },
    // Header 2
    typography2: {
        fontSize: "22px",
        fontWeight: 600,
        lineHeight: "28px",
        letterSpacing: "0.2px",
    },
    // Subheader 1
    typography3: {
        fontSize: "22px",
        fontWeight: 400,
        lineHeight: "28px",
        letterSpacing: "0.2px",
    },
    // Subhead 2
    typography4: {
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "28px",
        letterSpacing: "0.2px",
    },
    // Subhead 3
    typography5: {
        fontSize: "20px",
        fontWeight: 400,
        lineHeight: "28px",
        letterSpacing: "0.2px",
    },
    // Section Title 1
    oldTypography6: {
        fontSize: "18px",
        fontWeight: 600,
        lineHeight: "22px",
        letterSpacing: "0.2px",
    },
    // Body 1
    oldTypography7: {
        fontSize: "18px",
        fontWeight: 400,
        lineHeight: "22px",
        letterSpacing: "0.2px",
    },
    // Section Title 1
    typography6: {
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "22px",
        letterSpacing: "0.2px",
    },
    // Body 1
    typography7: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "22px",
        letterSpacing: "0.2px",
    },
    // Section Title 2
    oldTypography8: {
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "20px",
        letterSpacing: "0.2px",
    },
    // Body 2
    oldTypography9: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "22px",
        letterSpacing: "0.2px",
    },
    // Section Title 2
    typography8: {
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        letterSpacing: "0.2px",
    },
    // Body 2
    typography9: {
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "22px",
        letterSpacing: "0.2px",
    },
    // Body 3
    oldTypography10: {
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        letterSpacing: "0.2px",
    },
    // Body 4
    oldTypography11: {
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.2px",
    },
    // Body 3
    typography10: {
        fontSize: "13px",
        fontWeight: 600,
        lineHeight: "20px",
        letterSpacing: "0.2px",
    },
    // Body 4
    typography11: {
        fontSize: "13px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.2px",
    },
    // Small Text 1
    typographyNew12: {
        fontSize: "13px",
        fontWeight: 400,
        lineHeight: "16px",
        letterSpacing: "0.2px",
    },
    // Small Text 2
    oldTypography12: {
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: "16px",
        letterSpacing: "0.2px",
    },
    // Small Text 3
    oldTypography13: {
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "16px",
        letterSpacing: "0.2px",
    },
    // Small Text 2
    typography12: {
        fontSize: "11px",
        fontWeight: 600,
        lineHeight: "16px",
        letterSpacing: "0.2px",
    },
    // Small Text 3
    typography13: {
        fontSize: "11px",
        fontWeight: 400,
        lineHeight: "16px",
        letterSpacing: "0.2px",
    },
    // Graph Labels
    typography14: {
        fontSize: "11px",
        fontWeight: 400,
        lineHeight: "14px",
        letterSpacing: "0px",
    },
    typography15: {
        fontSize: "10px",
        fontWeight: 600,
        lineHeight: "13px",
        letterSpacing: "0px",
    },
    typography16: {
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "16px",
        letterSpacing: "0.2px",
    },
};

export default typography;
